import { 
    REFERRAL_ADDITIONAL_INFO_GET_REQUEST, REFERRAL_ADDITIONAL_INFO_GET_SUCCESS, REFERRAL_ADDITIONAL_INFO_GET_ERROR, 
    REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_REQUEST, REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_SUCCESS, REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_ERROR, 
    REFERRAL_ADDITIONAL_INFO_ADD_REQUEST, REFERRAL_ADDITIONAL_INFO_ADD_SUCCESS, REFERRAL_ADDITIONAL_INFO_ADD_ERROR, 
    REFERRAL_ADDITIONAL_INFO_EDIT_REQUEST, REFERRAL_ADDITIONAL_INFO_EDIT_SUCCESS, REFERRAL_ADDITIONAL_INFO_EDIT_ERROR, 
    REFERRAL_ADDITIONAL_INFO_DELETE_REQUEST, REFERRAL_ADDITIONAL_INFO_DELETE_SUCCESS, REFERRAL_ADDITIONAL_INFO_DELETE_ERROR
} from "../constants/referralAdditionalInfoConstants";

const initialState = {
    referralAdditionalInfos: [],
    referralAdditionalInfo: {},
    loading: false,
    success: null,
    error: null,
    referralAdditionalInfoRequestedCount: 0,
};

export const referralAdditionalInfoReducer = (state = initialState, action) => {
    switch (action.type)     {
        case REFERRAL_ADDITIONAL_INFO_GET_REQUEST:
            return {
                ...state,
                referralAdditionalInfoRequestedCount: ++state.referralAdditionalInfoRequestedCount,
                loading: true,
            };
        case REFERRAL_ADDITIONAL_INFO_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                referralAdditionalInfos: action.payload,
                success: true,
            };
        case REFERRAL_ADDITIONAL_INFO_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                referralAdditionalInfo: action.payload,
                success: true,
            };
        case REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ADDITIONAL_INFO_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ADDITIONAL_INFO_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_ADDITIONAL_INFO_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ADDITIONAL_INFO_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ADDITIONAL_INFO_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_ADDITIONAL_INFO_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_ADDITIONAL_INFO_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_ADDITIONAL_INFO_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_ADDITIONAL_INFO_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
